var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assign-items" }, [
    _c(
      "div",
      {
        staticClass:
          "col-md-12 row align-items-end no-padding no-margin subheader-assign d-flex align-items-center"
      },
      [
        _c("div", { staticClass: "col-8 no-padding" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("message.assignofitems", {
                  selected_count: this.input.length,
                  items_count: this.items.length
                })
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 no-padding text-right" }, [
          !_vm.disabled
            ? _c(
                "button",
                { staticClass: "btn btn-sm", on: { click: _vm.onSelectedAll } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("button.selectall")) +
                      "\n      "
                  )
                ]
              )
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-items" },
      _vm._l(_vm.mapItems, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            class: [
              "col-md-12 row align-items-center no-margin item",
              { active: item.active },
              { disabled: _vm.disabled }
            ],
            on: {
              click: function($event) {
                return _vm.toggle(item)
              }
            }
          },
          [
            _c("div", { class: "col-" + _vm.colName }, [
              _vm._v("\n        " + _vm._s(item.text) + "\n      ")
            ]),
            _vm._v(" "),
            _c("div", { class: "col-" + _vm.colValue + " text-right" }, [
              _vm._v("\n        " + _vm._s(item.label) + "\n        "),
              _c("i", { staticClass: "fas fa-check-circle" }),
              _vm._v(" "),
              _c("i", { staticClass: "far fa-circle" })
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1daf6f9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1daf6f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseAssignItems.vue
// module id = null
// module chunks = 